import { gql } from "@apollo/client";

export const addLibraryCategory = gql`
  mutation addLibraryCategory($record: CreateOneLibraryCategoryInput!) {
    libraryCategory_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;
